import {preReClick} from "@/directives/preReClick";//防抖
let directives=[
    preReClick,
]
export const registeDirective=(app)=>{
    directives.forEach(item=>item(app))
}